import { combineReducers } from 'redux';

import Statistics from '../App/containers/statistics/statistics.reducer';
import Login from '../App/containers/login/login.reducer';
import Admin from '../App/containers/admin/admin.reducer';
import Auth from '../App/auth.reducer';
import Rank from '../App/containers/ranking/ranking.reducer';

import { routerReducer } from 'react-router-redux';

const RootReducer = combineReducers({
    statistics: Statistics,
    login: Login,
    admin: Admin,
    router: routerReducer,
    auth: Auth,
    rank: Rank
});

export default RootReducer;


// WEBPACK FOOTER //
// ./src/config/root-reducer.js